import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pb-30 px-10 md-down:px-4" }
const _hoisted_2 = { class: "__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.5 7L10.5 14L17.5 21",
    stroke: "#94A3B8",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_4 = { class: "flex items-center justify-center" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-nowrap items-center gap-8 items-stretch" }
const _hoisted_7 = { class: "w-1/2 p-4 shadow-sm rounded-xl bg-white" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm" }, "Tổng số học sinh", -1)
const _hoisted_9 = { class: "font-bold text-4xl text-neutral-700" }
const _hoisted_10 = { class: "w-1/2 p-4 shadow-sm rounded-xl bg-white" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm" }, " Giáo viên bán trú ", -1)
const _hoisted_12 = { class: "font-bold text-4xl text-neutral-700" }
const _hoisted_13 = { class: "w-1/2 p-4 shadow-sm rounded-xl bg-white" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm" }, "Ngày học", -1)
const _hoisted_15 = { class: "font-bold text-4xl text-neutral-700" }
const _hoisted_16 = { class: "mt-10" }
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_19 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_20 = { class: "shadow overflow-hidden sm:rounded-lg" }
const _hoisted_21 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Tên hiển thị "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " TUỔI "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Ngày học "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " TLV phụ trách can thiệp "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-32" })
  ])
], -1)
const _hoisted_23 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_25 = { class: "flex items-center mb-2" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_28 = { class: "ml-4 text-orange-600 font-semibold" }
const _hoisted_29 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_30 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_31 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_32 = { class: "flex items-center mb-2" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_35 = { class: "ml-4 font-semibold text-blue-600" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5 1.125C5 0.779822 4.72018 0.5 4.375 0.5C4.02982 0.5 3.75 0.779822 3.75 1.125V1.75H2.5C1.11929 1.75 0 2.86929 0 4.25V5.5H20V4.25C20 2.86929 18.8807 1.75 17.5 1.75H16.25V1.125C16.25 0.779822 15.9702 0.5 15.625 0.5C15.2798 0.5 15 0.779822 15 1.125V1.75H5V1.125ZM20 18V6.75H0V18C0 19.3807 1.11929 20.5 2.5 20.5H17.5C18.8807 20.5 20 19.3807 20 18ZM11.875 9.25C11.5298 9.25 11.25 9.52982 11.25 9.875V11.125C11.25 11.4702 11.5298 11.75 11.875 11.75H13.125C13.4702 11.75 13.75 11.4702 13.75 11.125V9.875C13.75 9.52982 13.4702 9.25 13.125 9.25H11.875ZM15.625 9.25C15.2798 9.25 15 9.52982 15 9.875V11.125C15 11.4702 15.2798 11.75 15.625 11.75H16.875C17.2202 11.75 17.5 11.4702 17.5 11.125V9.875C17.5 9.52982 17.2202 9.25 16.875 9.25H15.625ZM2.5 13.625C2.5 13.2798 2.77982 13 3.125 13H4.375C4.72018 13 5 13.2798 5 13.625V14.875C5 15.2202 4.72018 15.5 4.375 15.5H3.125C2.77982 15.5 2.5 15.2202 2.5 14.875V13.625ZM6.875 13C6.52982 13 6.25 13.2798 6.25 13.625V14.875C6.25 15.2202 6.52982 15.5 6.875 15.5H8.125C8.47018 15.5 8.75 15.2202 8.75 14.875V13.625C8.75 13.2798 8.47018 13 8.125 13H6.875Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UpdateCalenderDaycareStudent = _resolveComponent("UpdateCalenderDaycareStudent")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_UpdateCalenderDaycareStudent, {
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalIsOpen = false)),
          onUpdated: _ctx.updatedCalender,
          days: _ctx.getDaysData(_ctx.studentSelected.id),
          student: _ctx.studentSelected,
          boarding: _ctx.classDetail
        }, null, 8, ["onUpdated", "days", "student", "boarding"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl cursor-pointer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/daycare-class')))
        }, [
          _hoisted_3,
          _createTextVNode(" Lớp bán trú: " + _toDisplayString(_ctx.classDetail.name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "h-12 button-p btn--ghost text-center mr-3 px-6 whitespace-nowrap",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push(`/add-students/${_ctx.id}`)))
          }, " Thêm học sinh ")
        ])
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.total), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.totalTeacher), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.dayOfWeekDisplay), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("table", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.students, (student, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: student.id,
                              class: _normalizeClass(
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											)
                            }, [
                              _createElementVNode("td", _hoisted_23, _toDisplayString(index + 1), 1),
                              _createElementVNode("td", _hoisted_24, [
                                _createVNode(_component_router_link, {
                                  to: `/record/student/${student?.id}`
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_25, [
                                      (
																student
																	?.profile_photo
																	?.w200
															)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "shadow-sm inline-block h-6 w-6 rounded-full",
                                            src: 
																student
																	?.profile_photo
																	?.w200
															,
                                            alt: ""
                                          }, null, 8, _hoisted_26))
                                        : (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                                            style: _normalizeStyle({
																background:
																	student
																		?.profile_photo
																		?.default
																		?.color,
															})
                                          }, [
                                            _createElementVNode("span", _hoisted_27, _toDisplayString(student
																		?.profile_photo
																		?.default
																		?.initial), 1)
                                          ], 4)),
                                      _createElementVNode("div", _hoisted_28, _toDisplayString(student?.name), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _createElementVNode("td", _hoisted_29, _toDisplayString(student.age), 1),
                              _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.getDays(student.id)), 1),
                              _createElementVNode("td", _hoisted_31, [
                                (student.main_staff)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: `/record/employee/${student?.main_staff?.id}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_32, [
                                          (
																student
																	.main_staff
																	?.profile_photo
																	?.w200
															)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                class: "shadow-sm inline-block h-6 w-6 rounded-full",
                                                src: 
																student
																	.main_staff
																	?.profile_photo
																	?.w200
															,
                                                alt: ""
                                              }, null, 8, _hoisted_33))
                                            : (_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                                                style: _normalizeStyle({
																background:
																	student
																		.main_staff
																		?.profile_photo
																		?.default
																		?.color,
															})
                                              }, [
                                                _createElementVNode("span", _hoisted_34, _toDisplayString(student
																		.main_staff
																		?.profile_photo
																		?.default
																		?.initial), 1)
                                              ], 4)),
                                          _createElementVNode("div", _hoisted_35, _toDisplayString(student
																	.main_staff
																	?.name), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, [
                                (_openBlock(), _createElementBlock("svg", {
                                  width: "20",
                                  height: "21",
                                  viewBox: "0 0 20 21",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  onClick: _withModifiers(($event: any) => (
														_ctx.updateCalender(student)
													), ["stop"]),
                                  class: "text-yellow-600 hover:text-yellow-700 active:text-yellow-500 cursor-pointer"
                                }, _hoisted_38, 8, _hoisted_36))
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createVNode(_component_Loading)
          ]))
    ])
  ], 64))
}